import { render } from "./pending_payments.vue?vue&type=template&id=aaaedef2"
import script from "./pending_payments.vue?vue&type=script&lang=js"
export * from "./pending_payments.vue?vue&type=script&lang=js"

import "./pending_payments.vue?vue&type=style&index=0&id=aaaedef2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__